import { Avatar } from "@mui/material";
import moment from "moment";
import React from "react";
import { communityHandScreenshot, communityHeart } from "src/assets";
import { get_date_of_user_time_zone } from "src/utils/constants";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";

export default function UserInfoCard({
  profile_image,
  user_name,
  date,
  activity_type,
  avatar_char,
}) {
  // const { userInfo, adminTimeZone } = useContentSetting();
  const userInfo = useContentSetting();

  return (
    <>
      <div className="post-creator user-info-card">
        <div className="like-profile-image">
          <Avatar src={profile_image} alt="photoURL">
            {avatar_char}
          </Avatar>
          {(activity_type === "like" || activity_type === "gratitude") && (
            <div className="tiny-like-icon">
              {activity_type === "like" ? (
                <img src={communityHeart} alt="" />
              ) : (
                <img src={communityHandScreenshot} alt="" />
              )}
            </div>
          )}
        </div>
        <div className="creator-name ps-2 pt-1 text-start">
          <span className="d-flex feed-level">
            <h3 className="mb-0">{user_name}</h3>
          </span>

          <span className="date-color">
            {/* {moment(date).format("DD MMM YYYY [at] hh:mm A")} */}
            {get_date_of_user_time_zone(
              date,
              "DD MMM YYYY [at] hh:mm A",
              userInfo?.userInfo?.time_zone
            )}
          </span>
        </div>
      </div>
    </>
  );
}
